import React from 'react';

import styles from './GeoBlock.css';

import type { IGeoLabel } from 'fragments/OfferCardWidget/shared/types/geo';

interface IGeoBlockProps {
  geoLabels: IGeoLabel[];
}

export const GeoBlock: React.FC<React.PropsWithChildren<IGeoBlockProps>> = ({ geoLabels, children }) => {
  return (
    <div className={styles['row']}>
      {children}
      <div className={styles['labels']}>
        {geoLabels.map((label, index) => {
          const item = (
            <span key={`offer-card-geo-${label.label}`} className={styles['label']}>
              {label.label}
            </span>
          );

          return [index > 0 && ', ', item];
        })}
      </div>
    </div>
  );
};
